import { getOssAccessUrl } from "@/api/file";
import type { OssFileDisposition, OssFileUploadVO } from "@/api/file/type";

/**
 * 根据业务库 OSS URL 换取短时签名访问 URL
 * @param fileUrl 详情中的 OSS 公网 URL
 * @param disposition inline=预览，attachment=下载
 */
export const resolveOssAccessUrl = async (
  fileUrl: string,
  disposition: OssFileDisposition = "inline",
): Promise<string> => {
  const res = await getOssAccessUrl({ fileUrl, disposition });
  return res.data.accessUrl;
};

/**
 * 获取 OSS 短时签名 URL 并打开
 * @param ossFile 已上传文件信息
 * @param disposition inline=预览，attachment=下载
 */
export const openOssFile = async (ossFile: OssFileUploadVO, disposition: OssFileDisposition) => {
  const accessUrl = await resolveOssAccessUrl(ossFile.url, disposition);
  window.open(accessUrl, "_blank", "noopener,noreferrer");
};
